module.exports = __webpack_public_path__ + "img/thumb_26.cc0511d5.jpg";